import React from "react";
import Market from "../components/Market";
import Header from "../layout/Header/header";

const MarketPlace = () => {
  return (
    <div className="market-bg">
      <Header />
      <Market />
    </div>
  );
};

export default MarketPlace;
